var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project.startimage)?_c('v-img',{staticClass:"white--text",attrs:{"src":(_vm.apiUrl + "/data/images/" + (_vm.project.startimage))}}):_c('div',{staticClass:"headline",domProps:{"textContent":_vm._s(_vm.project.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }